'use client';
import { ListboxSection } from '../listbox/listbox-section.component.js';

const ComboboxSection = ListboxSection;
ListboxSection.displayName = 'ComboboxSection';

export { ComboboxSection };
